module.exports = __webpack_public_path__ + "img/ico-arrow-neutral.8dad9b72.svg";